import { CorporatePartHelper } from 'corporate/helpers';
import { ICorporatePart } from 'corporate/types';

import { useCanManageParts } from './useCanManageParts';

export const useIsCorporatePartEditable = (corporatePart?: Partial<ICorporatePart>): boolean => {
  const canManageParts = useCanManageParts();

  if (!canManageParts) {
    return false;
  }

  return CorporatePartHelper.isEditable(corporatePart);
};
